import { GET_SINGLE_POST } from "./types";
import axios from "axios";

export default id => async dispatch => {
  const res = await axios.get(`/api/posts/${id}`);
  if (res.data.content) {
    res.data.content = JSON.parse(res.data.content);
  }
  if (res.data.content_html) {
    res.data.content_html = JSON.parse(res.data.content_html);
  }
  dispatch(getAsync(res.data));
};
const getAsync = data => ({
  type: GET_SINGLE_POST,
  payload: data
});
